import { GetStaticProps } from 'next';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import Footer from '@/components/footer/FooterWrapper';
import Layout from '@/components/layout/LayoutWrapper';
import NotFound from '@/components/notFound/NotFound';
import { InitRequest, useInitState } from '@/hooks/store';
import messages from '@/messages/messages';
import { setTheme } from '@/store/theme/actions';

const NotFoundPage = (): JSX.Element => {
	useInitState({
		requests: [InitRequest.USER, InitRequest.DEVICE],
	});

	const { formatMessage } = useIntl();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(
			setTheme({
				webAppLayout: null,
				header: 'dark',
				footer: 'dark',
			}),
		);
	}, [dispatch]);

	return (
		<Layout pageName="not-found" title={`Calm - ${formatMessage(messages.pageNotFoundTitle)}`}>
			<NotFound />
			<Footer />
		</Layout>
	);
};

export const getStaticProps: GetStaticProps = async () => {
	return {
		props: {},
		revalidate: 60, // 1 minute
	};
};

export default NotFoundPage;
